import colors from 'assets/styles/jsVariables/colors';

const modalTitle = {
  textAlign: 'center',
  marginTop: '19px',
  fontFamily: 'museosansrounded_500',
  color: colors.darkerGrey,
  fontSize: '22px',
  letterSpacing: '0.37px',
  lineHeight: '27px'
};

export default {
  AccountDetailsButtonStyle: {
    backgroundColor: colors.lighterCyan,
    height: '45px',
    width: '200px',
    margin: 'auto',
    display: 'inline-block',
    '@media (max-width: 767px)': {
      display: 'block',
    },
  },
  AccountDetailsButtonLabelStyle: {
    color: colors.white,
    fontFamily: 'museosansrounded_500',
    fontSize: '14px',
    letterSpacing: '0.26px',
    lineHeight: '17px',
    textTransform: 'none'
  },
  modalStyleVerifyEmail: {
    titleStyle: modalTitle,
    paperStyle: { borderRadius: '10px', maxWidth: '680px', width: '100%' },
    titleContainerStyle: { paddingLeft: 20, paddingRight: 20 },
    childrenStyle: {
      overflowY: 'auto',
      paddingLeft: 20,
      paddingRight: 20,
      paddingBottom: 73
    },
    containerStyle: { zIndex: 999999999 }
  },
  modalStyleResetPasswordEmail: {
    titleStyle: modalTitle,
    paperStyle: { borderRadius: '10px', maxWidth: '680px', width: '100%' },
    titleContainerStyle: { paddingLeft: 20, paddingRight: 20 },
    childrenStyle: {
      overflowY: 'auto',
      paddingLeft: 20,
      paddingRight: 20,
      paddingBottom: '42px'
    },
  },
  modalStyleAdditionalInfo: {
    titleStyle: modalTitle,
    paperStyle: { borderRadius: '10px', maxWidth: '680px', width: '100%' },
    titleContainerStyle: { paddingLeft: 20, paddingRight: 20 },
    childrenStyle: {
      overflowY: 'auto',
      paddingLeft: 50,
      paddingRight: 50,
      paddingBottom: '56px'
    },
  },
};



// WEBPACK FOOTER //
// ./src/views/SubscriptionActivate/AccountDetails/style.js